<template>
  <v-card outlined class="mb-3 mx-3">
    <div class="text-center area__sty">
      <button
        :id="group_uuid"
        :class="disabled_sty"
        class="goorder v-btn v-btn--block v-btn--contained theme--light v-size--large white--text mb-3"
        :data-useruuid="user_uuid"
        @click="checkOrderData()"
        :disabled="cantsendclick"
      >
        <span v-if="!isSendLoading">{{$t('sendOrderData_button1')}}</span>
        <span v-else>{{$t('sendOrderData_button2')}}</span>
      </button>
      <p class="warn__sty">{{$t('sendOrderData_text1')}}</p>
    </div>
    <!-- aftee -->
    <button id="np-button" @click="afteeFinal()" v-show="false">前往付款</button>
    <!-- 藍新 blue money -->
    <form   
      method="POST"
      id="bluemoneyForm"
      :action="getbluemoneyForm"
    >
      <input id="order_uuid" type="hidden" name="order_uuid" :value="sendbluemoney[0].order_uuid" >
      <input id="order_id" type="hidden" name="order_id" :value="sendbluemoney[0].order_id" >
      <input id="price" type="hidden" name="price" :value="sendbluemoney[0].price" >
      <input id="email" type="hidden" name="email" :value="sendbluemoney[0].email" >
      <input id="production" type="hidden" name="production" :value="sendbluemoney[0].production" >
    </form>
    <!-- 街口 JKO -->
    <form
      method="POST"
      id="jkoForm"
      :action="getjkoForm"
    >
      <input id="jko_order_uuid" name="order_uuid" type="hidden" :value="sendbluemoney[0].order_uuid" >
      <input id="jko_order_id" name="order_id" type="hidden" :value="sendbluemoney[0].order_id" >
      <input id="jko_price" name="price" type="hidden" :value="sendbluemoney[0].price" >
      <input id="jko_production" name="production" type="hidden" :value="sendbluemoney[0].production" >
    </form>
    <!-- line pay -->
    <form
      method="POST"
      id="linepayForm"
      :action="getlinepayForm"
    >
      <input id="linepay_order_uuid" type="hidden" name="order_uuid" :value="sendbluemoney[0].order_uuid" >
      <input id="linepay_order_id" type="hidden" name="order_id" :value="sendbluemoney[0].order_id" >
      <input id="linepay_price" type="hidden" name="price" :value="sendbluemoney[0].price" >
      <input id="linepay_email" type="hidden" name="email" :value="sendbluemoney[0].email" >
      <input id="linepay_production" type="hidden" name="production" :value="sendbluemoney[0].production" >
    </form>
    <!-- 虛擬ATM -->
    <form
      method="POST"
      id="atmForm"
      :action="getatmForm"
    >
      <input id="atm_order_uuid" type="hidden" name="order_uuid" :value="sendbluemoney[0].order_uuid" >
      <input id="atm_order_id" type="hidden" name="order_id" :value="sendbluemoney[0].order_id" >
      <input id="atm_price" type="hidden" name="price" :value="sendbluemoney[0].price" >
      <input id="atm_email" type="hidden" name="email" :value="sendbluemoney[0].email" >
      <input id="atm_production" type="hidden" name="production" :value="sendbluemoney[0].production" >
    </form>
  </v-card>
</template>

<script>
export default {
  name: 'sendOrderData',

  data: () => ({
    access_key: 'rIhTQzuOwZ54asxqRMNkYVF3n6UA7v9c',
    user_uuid: sessionStorage.getItem('user_uuid'),
    group_uuid: sessionStorage.getItem('group_uuid'),
    cantsendclick: false,
    isSendLoading: false,
    // get final send back data
    sendbluemoney: [
      {
        order_uuid: '',
        order_id: '',
        price: '',
        email: '',
        production: '',
      },
    ],
    // 智販機
    shippingtype: '您確定要送出訂單嗎？',
  }),
  computed: {
    disabled_sty() {
      // console.log(this.cantsendclick);
      if (this.cantsendclick === true) {
        return 'v-btn--disabled';
      } else {
        return 'button__sty';
      }
    },
    // set pay type url
    getbluemoneyForm() {
      const bluemoney_url = `https://${process.env.VUE_APP_API}.cheerlife.io/12team/v1/grouporder/pay`;
      return bluemoney_url;
    },
    getlinepayForm() {
      const linepay_url = `https://${process.env.VUE_APP_API}.cheerlife.io/12team/v1/grouporder/linepay`;
      return linepay_url;
    },
    getjkoForm() {
      const jkopay_url = `https://${process.env.VUE_APP_JKOAPI}.cheerlife.io/12team/v1/groups/122345/form_jko_entry`;
      return jkopay_url;
    },
    getatmForm() {
      const atmpay_url = `https://${process.env.VUE_APP_API}.cheerlife.io/12team/v1/grouporder/atm-pay`;
      return atmpay_url;
    }
  },
  methods: {
    async checkOrderData() {
      // this.cantsendclick = true;
      if (this.$store.state.productinfo.productinfoData[0].vending_machine === true) {
        this.shippingtype = '訂單完成後系統會直接發送取貨 QR Code 至收貨人 Email 及手機。\n您確定要送出訂單嗎？';
      } else {
        this.shippingtype = '您確定要送出訂單嗎？';
      }
      const result = confirm(this.shippingtype);
      if (result == false) {
        return false;
      } else {
        const mobile_re = /^[09]{2}[0-9]{8}$/;
        const email_re =  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        const final_total_price = parseInt(this.$store.state.shoplist.shoplistData[0].num_selection_calprice + this.$store.state.shoplist.shoplistData[0].num_selection_fee - this.$store.state.shoplist.shoplistData[0].is_coupon_price - this.$store.state.shoplist.shoplistData[0].is_star_price - this.$store.state.shoplist.shoplistData[0].is_shopmoney_price);
        // console.log(this.$store.state.userinfo.userinfoData[0]);
        // 地址(智販機不必填寫)
        if (this.$store.state.productinfo.productinfoData[0].vending_machine === false) {
          if (this.$store.state.userinfo.userinfoData[0].address_type === '2') {
            // 收件人選公司地址
            if (
              this.$store.state.userinfo.userinfoData[0].company_address === '' || 
              this.$store.state.userinfo.userinfoData[0].company_address === undefined) {
              alert('未填寫寄件人公司地址');
              this.cantsendclick = false;
              return false;
            } else if (
              this.$store.state.userinfo.userinfoData[0].company_name === '' || 
              this.$store.state.userinfo.userinfoData[0].company_name === undefined) {
              alert('未填寫寄件人公司');
              this.cantsendclick = false;
              return false;
            }
          } else if (this.$store.state.userinfo.userinfoData[0].address_type === '1') {
            // 收件人選其他地址
            if (
              this.$store.state.userinfo.userinfoData[0].city === '' || 
              this.$store.state.userinfo.userinfoData[0].city === undefined) {
              alert('未選取訂購人城市/地區');
              this.cantsendclick = false;
              return false;
            } else if (
              this.$store.state.userinfo.userinfoData[0].area === '' || 
              this.$store.state.userinfo.userinfoData[0].area === undefined) {
              alert('未填寫訂購人區/縣');
              this.cantsendclick = false;
              return false;
            } else if (
              this.$store.state.userinfo.userinfoData[0].address === '' || 
              this.$store.state.userinfo.userinfoData[0].address === undefined) {
              alert('未填寫訂購人地址');
              this.cantsendclick = false;
              return false;
            }
          } else {
            alert('未選擇訂購人地址');
            this.cantsendclick = false;
            return false;
          }
          if (this.$store.state.userinfo.userinfoData[0].rec_address_type === '2') {
            // 收貨人選公司地址
            if (
              this.$store.state.userinfo.userinfoData[0].rec_company_address === '' || 
              this.$store.state.userinfo.userinfoData[0].rec_company_address === undefined) {
              alert('未填寫收貨人公司地址');
              this.cantsendclick = false;
              return false;
            } else if (
              this.$store.state.userinfo.userinfoData[0].rec_company_name === '' || 
              this.$store.state.userinfo.userinfoData[0].rec_company_name === undefined) {
              alert('未填寫收貨人公司');
              this.cantsendclick = false;
              return false;
            }
          } else if (this.$store.state.userinfo.userinfoData[0].rec_address_type === '1') {
            // 收貨人選其他地址
            if (
              this.$store.state.userinfo.userinfoData[0].rec_city === '' || 
              this.$store.state.userinfo.userinfoData[0].rec_city === undefined) {
              alert('未選取收貨人城市/地區');
              this.cantsendclick = false;
              return false;
            } else if (
              this.$store.state.userinfo.userinfoData[0].rec_area === '' || 
              this.$store.state.userinfo.userinfoData[0].rec_area === undefined) {
              alert('未填寫收貨人區/縣');
              this.cantsendclick = false;
              return false;
            } else if (
              this.$store.state.userinfo.userinfoData[0].rec_address === '' || 
              this.$store.state.userinfo.userinfoData[0].rec_address === undefined) {
              alert('未填寫收貨人地址');
              this.cantsendclick = false;
              return false;
            }
          } else {
            alert('未選擇收件人地址');
            this.cantsendclick = false;
            return false;
          }
        }
        if (
          this.access_key == '' || 
          this.access_key == undefined
        ) {
          alert('資訊不完整');
          this.cantsendclick = false;
          return false;
        } else if (
          this.$store.state.userinfo.userinfoData[0].name == '' || 
          this.$store.state.userinfo.userinfoData[0].name == undefined) {
          alert('未填寫訂購人姓名');
          this.cantsendclick = false;
          return false;
        } else if (
          this.$store.state.userinfo.userinfoData[0].mobile == '' || 
          this.$store.state.userinfo.userinfoData[0].mobile == undefined) {
          alert('未填寫訂購人電話');
          this.cantsendclick = false;
          return false;
        } else if (!mobile_re.test(this.$store.state.userinfo.userinfoData[0].mobile)) {
          alert('訂購人手機格式錯誤');
          this.cantsendclick = false;
          return false;
        } else if (
          this.$store.state.userinfo.userinfoData[0].email == '' || 
          this.$store.state.userinfo.userinfoData[0].email == undefined) {
          alert('未填寫訂購人信箱');
          this.cantsendclick = false;
          return false;
        } else if (!email_re.test(this.$store.state.userinfo.userinfoData[0].email)) {
          alert('訂購人信箱格式錯誤');
          this.cantsendclick = false;
          return false;
        } else if (
          this.$store.state.userinfo.userinfoData[0].rec_name == '' || 
          this.$store.state.userinfo.userinfoData[0].rec_name == undefined) {
          alert('未填寫收貨人姓名');
          this.cantsendclick = false;
          return false;
        } else if (
          this.$store.state.userinfo.userinfoData[0].rec_mobile == '' || 
          this.$store.state.userinfo.userinfoData[0].rec_mobile == undefined) {
          alert('未填寫收貨人手機');
          this.cantsendclick = false;
          return false;
        } else if (!mobile_re.test(this.$store.state.userinfo.userinfoData[0].rec_mobile)) {
          alert('收貨人手機格式錯誤');
          this.cantsendclick = false;
          return false;
        } else if (
          this.$store.state.userinfo.userinfoData[0].rec_email == '' || 
          this.$store.state.userinfo.userinfoData[0].rec_email == undefined) {
          alert('未填寫收貨人信箱');
          this.cantsendclick = false;
          return false;
        } else if (!email_re.test(this.$store.state.userinfo.userinfoData[0].rec_email)) {
          alert('收貨人信箱格式錯誤');
          this.cantsendclick = false;
          return false;
        } else if (this.$store.state.productinfo.productinfoData[0].product_pay_type_choose === 4 && final_total_price < 1000) {
          alert(this.$t('payType_text1'));
          this.cantsendclick = false;
          return false;
        } else {
          this.cantsendclick = true;
          try {
            // console.log(this.$store.state.productinfo.productinfoData[0].product_pay_type);
            // console.log(this.$store.state.productinfo.productinfoData[0]);
            this.cantsendclick = true;
            this.isSendLoading = true;
            let response = await this.SendAxiosFinalDatas();
            // console.log(response);
            sessionStorage.setItem('order_uuid', response.data.order_uuid);
            // wait res back
            this.sendbluemoney[0].order_uuid = response.data.order_uuid;
            this.sendbluemoney[0].order_id = response.data.order_id;
            this.sendbluemoney[0].price = parseInt(response.data.price);
            this.sendbluemoney[0].email = response.data.email;
            this.sendbluemoney[0].production = 'cheerlife訂單';
            await this.SendFinalData();
          } catch (error) {
            this.cantsendclick = false;
            alert('失敗！！');
            alert(error);
            return false;
          }
        }
      }
    },
    SendAxiosFinalDatas() {
      const totalprice = parseInt(this.$store.state.shoplist.shoplistData[0].num_selection_calprice + this.$store.state.shoplist.shoplistData[0].num_selection_fee - this.$store.state.shoplist.shoplistData[0].is_coupon_price - this.$store.state.shoplist.shoplistData[0].is_star_price - this.$store.state.shoplist.shoplistData[0].is_shopmoney_price);
      return new Promise((resolve, reject) => {
        this.axios({
          method: 'post',
          url: `https://${process.env.VUE_APP_API}.cheerlife.io/cheerlife/v2/web-users/add-order`,
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('accessToken')}`
          },
          data: {
            user_uuid: this.user_uuid,
            product_id: this.$store.state.productinfo.productinfoData[0].product_id,
            group_uuid: this.group_uuid,
            qty: parseInt(this.$store.state.shoplist.shoplistData[0].num_selection),
            deliver_type_id: 1,
            shipping_fee: parseInt(this.$store.state.shoplist.shoplistData[0].num_selection_fee),
            // 訂購人
            user_order_name: this.$store.state.userinfo.userinfoData[0].name,
            user_order_mobile: this.$store.state.userinfo.userinfoData[0].mobile,
            user_order_email: this.$store.state.userinfo.userinfoData[0].email,
            order_address_type: parseInt(this.$store.state.userinfo.userinfoData[0].address_type),
            user_order_city: this.$store.state.userinfo.userinfoData[0].city,
            user_order_area: this.$store.state.userinfo.userinfoData[0].area,
            user_order_address: this.$store.state.userinfo.userinfoData[0].address,
            company_address: this.$store.state.userinfo.userinfoData[0].company_address,
            company_name: this.$store.state.userinfo.userinfoData[0].company_name,
            // 收件人
            user_rec_name: this.$store.state.userinfo.userinfoData[0].rec_name,
            user_rec_mobile: this.$store.state.userinfo.userinfoData[0].rec_mobile,
            user_rec_email: this.$store.state.userinfo.userinfoData[0].rec_email,
            rec_address_type: parseInt(this.$store.state.userinfo.userinfoData[0].rec_address_type),
            user_rec_city: this.$store.state.userinfo.userinfoData[0].rec_city,
            user_rec_area: this.$store.state.userinfo.userinfoData[0].rec_area,
            user_rec_address: this.$store.state.userinfo.userinfoData[0].rec_address,
            rec_company_address: this.$store.state.userinfo.userinfoData[0].rec_company_address,
            rec_company_name: this.$store.state.userinfo.userinfoData[0].rec_company_name,
            // 發票 1: 收貨人 2: 訂購人
            receipt_send_type: 2,
            // 統編
            receipt_company_name: this.$store.state.userinfo.userinfoData[0].receipt_company_name,
            receipt_company_id: this.$store.state.userinfo.userinfoData[0].receipt_company_id,
            // memo
            remark: this.$store.state.shoplist.shoplistData[0].memo,
            // 付款方式 信用卡付款: 1 貨到付款: 2 Line Pay: 3 aftee: 4
            pay_type: this.$store.state.productinfo.productinfoData[0].product_pay_type_choose,
            service_fee: 0,
            price: totalprice,
            spec_id: this.$store.state.shoplist.shoplistData[0].num_selection_id,
            // 電子發票
            // donate_invoice: ,
            // carrier_type: ,
            // carrier_num: ,
            // 是否為智販機
            vending_machine: this.$store.state.productinfo.productinfoData[0].vending_machine,
            // 使用折價方式
            // 0:未使用優惠 1:使用序號 2:使用星幣 3:使用購物金
            discount_type: parseInt(this.$store.state.productinfo.productinfoData[0].usecostprice),
            // 使用星幣金額
            use_cheer_point: parseInt(this.$store.state.shoplist.shoplistData[0].is_star_price),
            // 折價券序號
            coupon: this.$store.state.productinfo.productinfoData[0].coupon,
            // 購物金金額
            use_shop_money: parseInt(this.$store.state.productinfo.productinfoData[0].shopmoney),
          },
        })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error.response.data.message);
          if (error.response.data.message === 'token過期') {
            sessionStorage.setItem('accessToken', '');
            sessionStorage.setItem('user_uuid', '');
            document.cookie = 'accessToken' +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
            document.cookie = 'user_uuid' +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
            window.history.go(-1);
          }
        });
      })
    },
    // 0元訂單
    sendtoNoPay() {
      this.isSendLoading = false;
      window.location.href = `https://${process.env.VUE_APP_SHOPAPI}.cheerlife.io/api/pay/cash_on_delivery?order_uuid=${this.sendbluemoney[0].order_uuid}`;
    },
    // 藍新 BlueMoney
    sendtoBlueMoney() {
      this.isSendLoading = false;
      document.getElementById('bluemoneyForm').submit();
    },
    // 街口 JKO
    sendtoJKO() {
      this.isSendLoading = false;
      document.getElementById('jkoForm').submit();
    },
    // line pay
    sendtoLinePay() {
      this.isSendLoading = false;
      document.getElementById('linepayForm').submit();
    },
    // 虛擬 atm
    sendtoATM() {
      this.isSendLoading = false;
      document.getElementById('atmForm').submit();
    },
    // AFTEE
    AfteeInit() {
      let afteedata = { 
        amount: 0, // 付款金額:必填
        shop_transaction_no: '', // 店舖交易ID:必填
        //"user_no": "shop-user-no-001", // 商家會員ID:選填
        //"sales_settled": true, // 交易確認
        //"transaction_options": [3], //交易選項
        //"description_trans": "備註", //店舖交易備註:選填
        checksum: '', // 驗證碼 
        customer: { // :必填
          customer_name: "", 
          phone_number: "", 
          address: "", 
          email: ""
        },
        dest_customers: [{ 
          dest_customer_name: "", 
          dest_tel: "", 
          dest_address: "", 
        }],
        items: [ // 商品明細 
          {
            shop_item_id: "",
            item_name: "",
            item_price: 0,
            item_count: 0,
            item_url: ""
          },
          {
            shop_item_id: "shippingCharge",
            item_name: "運費",
            item_price: 0,
            item_count: 1,
            item_url: '',
          },
          {
            shop_item_id: "discountPrice",
            item_name: "折扣金額",
            item_price: 0,
            item_count: 1,
            item_url: '',
          }
        ]
      }
      this.$Aftee.config({
        pre_token: "",
        // 正式：iaDmIdMLO3j3fnoKtjUHDA 測試：ojPvAewHPIVraalVj4NBRQ
        pub_key: process.env.VUE_APP_PUBKEY,
        payment: afteedata,
        // 認證完成同時、亦或會員註冊完成同時呼叫
        authenticated: function(authentication_token, user_no) {
          // 設定callback
          sessionStorage.setItem('authentication_token', authentication_token);
          sessionStorage.setItem('user_no', user_no);
        },
        // 付款popup畫面關閉同時呼叫 
        cancelled: function() {
          // 設定callback
          window.history.pushState(null, null, "/shopbuy");
        },
        // 審查結果NG後、按下關閉認證表格按鍵同時呼叫 
        failed: function(response) {
          // 設定callback 
          alert("付款失敗，請重新訂購！");
          console.log(response);
          window.history.pushState(null, null, "/shopbuy");
        },
        // 審查結果OK後自動關閉認證表格同時呼叫 
        succeeded: function(response) {
          // 設定callback 
          let authentication_token = sessionStorage.getItem('authentication_token');
          let order_uuid = sessionStorage.getItem('order_uuid');
          window.location.href = `https://${process.env.VUE_APP_SHOPAPI}.cheerlife.io/api/pay/cash_on_delivery?order_uuid=${order_uuid}&aftee_id=${response.id}&token=${authentication_token}`;
        },
        // 發生錯誤時呼叫
        error: function(name, message, errors) {
        // 設定callback
          console.log(name);
          console.log(message);
          console.log(errors);
          // alert('發生錯誤，請重試');
          for (let i = 0; i < errors.length; i++) {
            for (let j = 0; j < errors[i].messages.length; j++) {
              alert(errors[i].messages[j]);
            }
          }
          window.history.pushState(null, null, "/cart");
        },
        function() {
          console.log("AFTEE初始化成功"), 
          this.$Aftee.merge({
            payment: afteedata
          }),
          this.$Aftee.sync(),
          this.$Aftee.start()
        }
      });
    },
    sendtoAFTEE() {
      this.cantsendclick = false;
      this.isSendLoading = false;
      let iteminfo_list_data = [];
      iteminfo_list_data.push(
        {
          "shopItemId": parseInt(this.$store.state.productinfo.productinfoData[0].product_id),
          "itemName": this.$store.state.productinfo.productinfoData[0].product_name,
          "itemPrice": parseInt(this.$store.state.shoplist.shoplistData[0].num_selection_price),
          "itemCount": parseInt(this.$store.state.shoplist.shoplistData[0].num_selection),
          "itemUrl": this.$store.state.productinfo.productinfoData[0].product_img,
        },
        {
          shopItemId: 'shippingCharge',
          itemName: '運費',
          itemPrice: parseInt(this.$store.state.shoplist.shoplistData[0].num_selection_fee),
          itemCount: 1,
          itemUrl: '',
        },{
          shopItemId: 'discountPrice',
          itemName: '折扣金額',
          itemPrice: Math.abs(this.$store.state.shoplist.shoplistData[0].is_star_price + this.$store.state.shoplist.shoplistData[0].is_coupon_price + this.$store.state.shoplist.shoplistData[0].is_shopmoney_price) * -1,
          itemCount: 1,
          itemUrl: '',
        }
      );
      console.log(iteminfo_list_data);
      this.axios({
        method: 'post',
        // 測試：1588198937
        // 正式：1588572393
        url: `https://${process.env.VUE_APP_SHOPAPI}.cheerlife.io/api/v1/72team/${process.env.VUE_APP_72TEAM}/getChecksum`,
        data: {
          user_id: sessionStorage.getItem('user_uuid'),
          itemInfoList: iteminfo_list_data,
          // 訂購人
          orderApplicantInfo: [{
            customerName: this.$store.state.userinfo.userinfoData[0].name,
            address: this.$store.state.orderinfo.orderinfoData[0].order_address,
            email: this.$store.state.userinfo.userinfoData[0].email,
            phone_number: this.$store.state.userinfo.userinfoData[0].mobile
          }],
          // 收件人
          orderSendInfo: [{
            destCustomerName: this.$store.state.userinfo.userinfoData[0].rec_name,
            destAddress: this.$store.state.recinfo.recinfoData[0].rec_address,
            destTel: this.$store.state.userinfo.userinfoData[0].rec_mobile
          }]
        },
      })
        .then((response) => {
          // console.log(response.data.checksum);
          // send aftee product data
          let aftee_item_list_data = [];
          aftee_item_list_data.push(
            {
              "shop_item_id": parseInt(this.$store.state.productinfo.productinfoData[0].product_id),
              "item_name": this.$store.state.productinfo.productinfoData[0].product_name,
              "item_price": parseInt(this.$store.state.shoplist.shoplistData[0].num_selection_price),
              "item_count": parseInt(this.$store.state.shoplist.shoplistData[0].num_selection),
              "item_url": this.$store.state.productinfo.productinfoData[0].product_img,
            },
            {
              shop_item_id: 'shippingCharge',
              item_name: '運費',
              item_price: parseInt(this.$store.state.shoplist.shoplistData[0].num_selection_fee),
              item_count: 1,
              item_url: '',
            },{
              shop_item_id: 'discountPrice',
              item_name: '折扣金額',
              item_price: Math.abs(this.$store.state.shoplist.shoplistData[0].is_star_price + this.$store.state.shoplist.shoplistData[0].is_coupon_price + this.$store.state.shoplist.shoplistData[0].is_shopmoney_price) * -1,
              item_count: 1,
              item_url: '',
            }
          );
          // console.log(aftee_item_list_data);
          // send final aftee
          sessionStorage.setItem('checksum', response.data.checksum);
          let afteedata = { 
            // 付款金額:必填
            amount: parseInt(this.$store.state.shoplist.shoplistData[0].num_selection_calprice + this.$store.state.shoplist.shoplistData[0].num_selection_fee - this.$store.state.shoplist.shoplistData[0].is_coupon_price - this.$store.state.shoplist.shoplistData[0].is_star_price - this.$store.state.shoplist.shoplistData[0].is_shopmoney_price),
            shop_transaction_no: this.sendbluemoney[0].order_id, // 店舖交易ID:必填
            //"user_no": "shop-user-no-001", // 商家會員ID:選填
            //"sales_settled": true, // 交易確認
            //"transaction_options": [3], //交易選項
            //"description_trans": "備註", //店舖交易備註:選填
            checksum: response.data.checksum, // 驗證碼 
            // 訂購人
            customer: { // :必填
              customer_name: this.$store.state.userinfo.userinfoData[0].name,
              phone_number: this.$store.state.userinfo.userinfoData[0].mobile,
              // "zip_code": "111",
              address: this.$store.state.orderinfo.orderinfoData[0].order_address,
              email: this.$store.state.userinfo.userinfoData[0].email
            },
            // 收件人
            dest_customers: [{
              dest_customer_name: this.$store.state.userinfo.userinfoData[0].rec_name,
              dest_tel: this.$store.state.userinfo.userinfoData[0].rec_mobile, 
              dest_address: this.$store.state.recinfo.recinfoData[0].rec_address
            }],
            // 商品明細
            items: aftee_item_list_data,
          }
          // console.log(afteedata);
          this.$Aftee.merge({
            payment: afteedata,
          }),
          this.$Aftee.sync(),
          this.$Aftee.start()
        })
        .catch((error) => {
          alert(error);
          this.cantsendclick = false;
        });
    },
    async SendFinalData() {
      const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));
      await sleep(2000);
      // 判斷是否0元訂單
      if (this.sendbluemoney[0].price === 0) {
        this.sendtoNoPay();
      } else {
        let paytype = this.$store.state.productinfo.productinfoData[0].product_pay_type_choose;
        if (paytype === 1) {
          this.sendtoBlueMoney();
        } else if (paytype === 3) {
          this.sendtoLinePay();
        } else if (paytype === 4) {
          this.sendtoAFTEE();
        } else if (paytype === 5) {
          this.sendtoJKO();
        } else if (paytype === 6) {
          this.sendtoATM();
        } else {
          return false;
        }
      }
    }
  },
  mounted() {
    this.AfteeInit();
  },
  watch: {
  },
};
</script>
<style rel="stylesheet/scss" lang="sass">
  button:disabled, button[disabled]
    border: 1px solid #999999
    background-color: #cccccc !important
    color: #666666
  .theme--light.v-card.v-card--outlined
    border: none
  .area__sty
    background-color: #fafafa
    border: none
  .button__sty
    background: #FF781E !important
  .warn__sty
    font-weight: bold
    font-size: 13px
    line-height: 17px
    letter-spacing: 0.1em
    color: #FF781E
</style>
